import type { AccountAuthz } from '../generated/openapi/befunde-api';

export { blobToDataUrl } from '@medcom/shared-ui/utils/helpers.ts';

export const buildAuthzInfo = (authz: AccountAuthz[]): string => {
  return authz.map(it => `${it.labId}: ${it.identifiers.join(', ')}`).join(' - ');
};
